

class BrixHeroAlternative {
  static init(...parameters) {
    return new BrixHeroAlternative(...parameters);
  }

  constructor(block) {
    if (block) {
      this.calculateAspectRatio(block);
    }
  }

  calculateAspectRatio(block) {
    const image = block.querySelector('.image');

    if (image) {
      const { aspectRatio } = image.dataset;
      if (aspectRatio) {
        image.style.aspectRatio = aspectRatio;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero-alternative', BrixHeroAlternative.init);
}
